export default [
  // Dashboard Links
  { // dashboards
    title: 'Dashboard',
    gjIcon: 'Chart',
    route: 'dashboard',
    action: 'read',
    resource: 'dashboard',
  },
  { // Videos Dashboard Links
    title: 'Videos',
    gjIcon: 'VideoSquare',
    children: [
      {
        title: 'Videos',
        route: 'videos',
        action: 'read',
        resource: 'video',
        module: 'videosModule',
      },
      {
        title: 'Playlists',
        route: 'playlists',
        action: 'read',
        resource: 'video',
        module: 'playlistsModule',
      },
    ],
  },
  { // Audios Dashboard Links
    title: 'Audios',
    gjIcon: 'AudioSquare',
    children: [
      {
        title: 'Audios',
        route: 'audios',
        action: 'read',
        resource: 'video',
        module: 'audiosModule',
      },
      {
        title: 'Podcasts',
        route: 'podcasts',
        action: 'read',
        resource: 'video',
      },
    ],
  },
  { // Livestream Dashboard Links
    title: 'Livestream',
    gjIcon: 'LiveStream',
    children: [
      {
        title: 'Live Videos',
        route: 'live-videos',
        action: 'read',
        resource: 'live-video',
        module: 'liveVideosModule',
      },
      {
        title: 'Live Channels',
        route: 'live-channels',
        action: 'read',
        resource: 'live-channel',
        module: 'channelsModule',
      },
    ],
  },
  { // Players Dashboard Links
    title: 'Players',
    gjIcon: 'MusicPlaylist',
    children: [
      {
        title: 'Video Players',
        route: 'video-players',
        action: 'read',
        resource: 'player',
        module: 'videoPlayersModule',
      },
      {
        title: 'Vertical Players',
        route: 'vertical-players-list',
        action: 'read',
        resource: 'player',
        module: 'verticalPlayersModule',
      },
      {
        title: 'Audio Players',
        route: 'audio-players-list',
        action: 'read',
        resource: 'player',
        module: 'audioPlayersModule',
      },
    ],
  },
  { // Ad Schedules Dashboard Links
    title: 'Revenue Management',
    gjIcon: 'TimeStart',
    children: [
      {
        title: 'Advertising',
        route: 'ad-schedules',
        action: 'read',
        resource: 'ads',
        module: 'adSchedulesModule',
      },
      {
        title: 'Demand Manager',
        route: 'demand-manager',
        action: 'read',
        resource: 'ads',
        module: 'wrapperModule',
      },
    ],
  },
  { // Analytics Dashboard Links
    title: 'Analytics',
    gjIcon: 'Analytics',
    children: [
      {
        title: 'Advanced Analytics',
        route: 'advanced-analytics',
        action: 'read',
        resource: 'real-time-analytics',
      },
      {
        title: 'Custom Reports',
        route: 'custom-reports',
        action: 'read',
        resource: 'custom-report',
        module: 'analyticsModule',
      },
      {
        title: 'Usage History',
        route: 'usage',
        action: 'read',
        resource: 'usage',
        module: 'analyticsModule',
      },
    ],
  },
  { // Security Dashboard Links
    title: 'Security',
    gjIcon: 'Security',
    route: 'api-keys',
    action: 'write',
    resource: 'user',
  },
  { // Properties Dashboard Links
    title: 'Properties',
    gjIcon: 'SettingsPreferencesTools',
    children: [
      { // Flags Dashboard Links
        title: 'Flags',
        route: 'flags',
        action: 'read',
        resource: 'flag',
        module: 'flagsModule',
      },
      { // Geoblocking Rules Dashboard Links
        title: 'Geoblocking rules',
        route: 'geo-blocking',
        action: 'read',
        resource: 'flag',
        module: 'geoBlockingModule',
      },
      { // Webhooks Dashboard Links
        title: 'Webhooks',
        route: 'webhooks',
        action: 'read',
        resource: 'project',
        module: 'webhooksModule',
      },
      { // Whitelists Dashboard Links
        title: 'Whitelisting Domains',
        route: 'whitelists',
        action: 'read',
        resource: 'video',
        module: 'whitelistsModule',
      },
    ],
  },
]
